import PermissionRoleIndex from "@/components/permission_role/PermissionRoleIndex.vue";
import PermissionRoleAdd from "@/components/permission_role/PermissionRoleAdd.vue";
import PermissionRoleDetail from "@/components/permission_role/PermissionRoleDetail.vue";
import PermissionRoleEdit from "@/components/permission_role/PermissionRoleEdit.vue";
import PermissionRoleUpload from "@/components/permission_role/PermissionRoleUpload.vue";

let routesPermissionRoleAccess= [
    {
        path: '',
        meta: {
          title: "List Permission Role Access",
        },
        name: "PermissionRoleIndex",
        component: PermissionRoleIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Permission Role Access",
        },
        name: "PermissionRoleAdd",
        component: PermissionRoleAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Permission Role Access",
        },
        name: "PermissionRoleDetail",
        component: PermissionRoleDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Permission Role Access",
        },
        name: "PermissionRoleEdit",
        component: PermissionRoleEdit
    },
     
    {
        path: 'upload',
        meta: {
          title: "Upload Permission Role Access",
        },
        name: "PermissionRoleUpload",
        component: PermissionRoleUpload
    },
    
]

export default routesPermissionRoleAccess
  